import { AxiosPromise } from '../../../utils/axios.promise';
import { CommonConfig } from '../../../configs/config.common';

export namespace CommonFunc {
    export async function getAgentInfoByYHId(yhId: string) {
        const apiHost = new CommonConfig().cimsServHost;
        const result = await AxiosPromise.get(`${apiHost}/rifoYh/getAgentInfoByYHId?yhId=${yhId}`);
        if (result.code === 200) {
            return result.data;
        } else {
            return undefined;
        }
    }

    export async function getStoreInfoByYhId(yhId: string) {
        const body = {
            ltype: 0,
            yhId: yhId
        };
        const apiHost = new CommonConfig().cimsServHost;
        const result = await AxiosPromise.postUrlEncode(`${apiHost}/resPartner/storeInfo`, body);
        if (result.status === 200) {
            if (result.data.code === 200) {
                return result.data.data;
            } else {
                return undefined;
            }
        } else {
            return undefined;
        }
    }
}
